import { render, staticRenderFns } from "./UserLevelSelect.vue?vue&type=template&id=3d5c4166&"
import script from "./UserLevelSelect.vue?vue&type=script&lang=ts&"
export * from "./UserLevelSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports